const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;

type RecipientListValue = string[] | string | undefined | null;

// Recipient lists are edited as tags; an entry may still hold several values (e.g. pasted "a@x.com; b@x.com").
export const parseRecipientList = (value: RecipientListValue): string[] => [
    ...new Set(
        (Array.isArray(value) ? value : [value || ''])
            .flatMap((entry) => entry.split(/[,;\n]/))
            .map((entry) => entry.trim())
            .filter(Boolean)
    ),
];

export const invalidRecipients = (value: RecipientListValue): string[] =>
    parseRecipientList(value).filter((email) => !EMAIL_PATTERN.test(email));

// An enabled channel needs at least one recipient and every entry must be an email address.
export const isValidRecipientList = (enabled: boolean, value: RecipientListValue): boolean =>
    !enabled || (parseRecipientList(value).length > 0 && invalidRecipients(value).length === 0);

// Domains the send_email tool may send to — mirrors the backend's validation ("example.com", no wildcards).
const EMAIL_DOMAIN_PATTERN = /^(?=.{1,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export const normaliseEmailDomain = (value: string): string => value.trim().toLowerCase().replace(/^@/, '');

export const invalidEmailDomains = (value: RecipientListValue): string[] =>
    parseRecipientList(value).filter((domain) => !EMAIL_DOMAIN_PATTERN.test(normaliseEmailDomain(domain)));
